export default __webpack_public_path__ + "b851b50.png";